import * as React from "react";
import {
  FILETEXT,
  SETTINGS2,
  USERS,
  BADGECHECK,
  IMAGE,
  CPU,
  MESSAGE,
  PACKAGE,
  VIDEO,
  TRENDINGUP,
} from "icons";
import { Outlet } from "react-router-dom";
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarHeader,
  SidebarMenu,
  SidebarProvider,
  SidebarRail,
} from "ui/components/sidebar";
import { NavItem } from "@/components/item";
import { useParams } from "react-router-dom";
import { useFetch } from "hooks/src/useFetch";
import { fetchCaseStudyDataforForm } from "./form/read";
import { CollapsibleProjectHeader } from "@/components/collapsible-header";

export default function CasestudyLayout({ ...props }) {
  const { casestudyId } = useParams();
  return (
    <div className="flex">
      <CasestudyFormLayoutContent casestudyId={casestudyId} {...props} />
    </div>
  );
}
function CasestudyFormLayoutContent({ casestudyId, ...props }) {
  const { data, isLoading, isError } = useFetch({
    queryKey: [casestudyId],
    queryFn: () =>
      fetchCaseStudyDataforForm({
        casestudyId: casestudyId,
        fields: ["name", "project.id", "project.name", "project.logo"],
      }),
  });
  return (
    <>
      <SidebarProvider
        className="w-fit overflow-hidden max-h-dvh"
        name="case_study"
      >
        <Sidebar
          collapsible="icon"
          {...props}
          className="sidebar-height border-r bg-red-400 left-auto inset-y-auto top-16"
        >
          <SidebarHeader className="p-0">
            <div className="p-4">
              <CollapsibleProjectHeader
                casestudy={data}
                isLoading={isLoading}
              />
            </div>
          </SidebarHeader>
          <SidebarContent>
            <SidebarGroup>
              <SidebarMenu>
                <NavItem
                  title="Basic Details"
                  icon={FILETEXT}
                  url={`/case-studies/${casestudyId}/edit/basic-details`}
                  matchExact={true}
                />
                <NavItem
                  title="Client Context"
                  icon={USERS}
                  url={`/case-studies/${casestudyId}/edit/client`}
                />
                <NavItem
                  title="Results"
                  icon={BADGECHECK}
                  url={`/case-studies/${casestudyId}/edit/results`}
                />
                <NavItem
                  title="Outcomes"
                  icon={TRENDINGUP}
                  url={`/case-studies/${casestudyId}/edit/outcomes`}
                />
                <NavItem
                  title="Tech Stack"
                  icon={CPU}
                  url={`/case-studies/${casestudyId}/edit/tech-stack`}
                />
                <NavItem
                  title="Tools"
                  icon={SETTINGS2}
                  url={`/case-studies/${casestudyId}/edit/tools`}
                />
                <NavItem
                  title="Deliverables"
                  icon={PACKAGE}
                  url={`/case-studies/${casestudyId}/edit/deliverables`}
                />
                <NavItem
                  title="Testimonials"
                  icon={MESSAGE}
                  url={`/case-studies/${casestudyId}/edit/testimonials`}
                />
                <NavItem
                  title="Screenshots	"
                  icon={IMAGE}
                  url={`/case-studies/${casestudyId}/edit/screenshots`}
                />
                <NavItem
                  title="Video"
                  icon={VIDEO}
                  url={`/case-studies/${casestudyId}/edit/video`}
                />
              </SidebarMenu>
            </SidebarGroup>
          </SidebarContent>
          <SidebarRail />
        </Sidebar>
      </SidebarProvider>

      <Outlet />
    </>
  );
}
